/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonStratUserInfo
 */
export interface JsonStratUserInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonStratUserInfo
     */
    allowedActions?: Array<JsonStratUserInfoAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    companyDepartmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    companyId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    companyPositionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    departmentId?: number;
    /**
     * 
     * @type {Date}
     * @memberof JsonStratUserInfo
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    parentUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    phone?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    positionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    roleCode?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    roleId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    roleTitle?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    stratUserId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    strategyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonStratUserInfo
     */
    userPath?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonStratUserInfo
     */
    userStatus?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonStratUserInfoAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}

export function JsonStratUserInfoFromJSON(json: any): JsonStratUserInfo {
    return JsonStratUserInfoFromJSONTyped(json, false);
}

export function JsonStratUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonStratUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'companyDepartmentId': !exists(json, 'companyDepartmentId') ? undefined : json['companyDepartmentId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyPositionId': !exists(json, 'companyPositionId') ? undefined : json['companyPositionId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'departmentId': !exists(json, 'departmentId') ? undefined : json['departmentId'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (new Date(json['dueDate'])),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'parentUserId': !exists(json, 'parentUserId') ? undefined : json['parentUserId'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'positionId': !exists(json, 'positionId') ? undefined : json['positionId'],
        'roleCode': !exists(json, 'roleCode') ? undefined : json['roleCode'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'roleTitle': !exists(json, 'roleTitle') ? undefined : json['roleTitle'],
        'stratUserId': !exists(json, 'stratUserId') ? undefined : json['stratUserId'],
        'strategyId': !exists(json, 'strategyId') ? undefined : json['strategyId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userPath': !exists(json, 'userPath') ? undefined : json['userPath'],
        'userStatus': !exists(json, 'userStatus') ? undefined : json['userStatus'],
    };
}

export function JsonStratUserInfoToJSON(value?: JsonStratUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'companyDepartmentId': value.companyDepartmentId,
        'companyId': value.companyId,
        'companyPositionId': value.companyPositionId,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'departmentId': value.departmentId,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate.toISOString().substr(0,10)),
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'parentUserId': value.parentUserId,
        'phone': value.phone,
        'positionId': value.positionId,
        'roleCode': value.roleCode,
        'roleId': value.roleId,
        'roleTitle': value.roleTitle,
        'stratUserId': value.stratUserId,
        'strategyId': value.strategyId,
        'teamName': value.teamName,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userId': value.userId,
        'userPath': value.userPath,
        'userStatus': value.userStatus,
    };
}

